import React, {useState ,useEffect} from 'react'
import './Nav.css';
function Nav() {
    const [show,handleShow]=useState(false);
    useEffect(()=>
    {
        window.addEventListener("scroll", () =>
        {
            if(window.scrollY>100)
            {
                handleShow(true);
            }
            else handleShow(false);
        });
        return() =>
        {
            window.removeEventListener('scroll',null);
        }

    },[] );
  return (
    <div className={`nav ${show && "nav_black"}`}>
        <img
        className="nav_logo"
        src="https://thereelbits.com/wp-content/uploads/2017/05/Netflix-Logo.jpg"
        alt="Netflix Logo">
        </img>
        <img
        className="nav_avatar"
        src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
        alt="Netflix Logo">
        </img>

    </div>
  )
}

export default Nav